export default __webpack_public_path__ + "static/media/mipox-abrasives.ab259646.webp";